
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Link } from '@mui/material';

import { useEffect, useState } from 'react';
import styled from "styled-components";

import Config from '../config.json';

import { setCookie } from '../Helpers';

import background from '../dion-beetson-oF7hh97lVqA-unsplash.jpg';

export default function Login({ setIsForgot }) {
    const SITE_KEY = "6LdXlSweAAAAAEOM5Cuh-GPohJYx6MIvsVuZwa0v";
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);

    const url_login = "../api/auth/login";
    useEffect(() => {
        //console.log(SITE_KEY)
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }

        // load the script by passing the URL
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
            console.log("Script loaded!");
        });
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        if (!loading) {
            setSuccess(false);
            setLoading(true);
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
                    postData(token);
                });
            });
            

            //timer.current = window.setTimeout(() => {
            //    setSuccess(true);
            //    setLoading(false);
            //}, 2000);
        }
    };

    function validateForm() {
        return !loading && email.length > 0 && password.length > 0;
    }


    const postData = async (token) => {
        console.log(token)
        
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "email": email,
                    "password": password,
                    "token": token
                })
            };

            const response = await fetch(url_login, requestOptions)
            var json = await response.json();
            if (response.status === 200) {

                if (json.Authorization) {
                    setPassword("");
                    setCookie('USER_TOKEN', json.Authorization);
                    setCookie('CONTRIBUTOR',  json.username);
                    setCookie('PUBLIC_ID',  json.public_id);
                    //setCountry('CONTRIBUTOR', username);

                    setSuccess(true);
                    setLoading(false);
                    setOpen(true);
                    setMessage("You are successfully logged in");
                    //setAuth(true);
                    window.location.reload();
                } else {
                    setSuccess(false);
                    setLoading(false);
                    setOpen(true);
                    //setAuth(false);
                    setMessage(json.message);
                }
            } else {
                setSuccess(false);
                setLoading(false);
                setOpen(true);
                //setAuth(false);
                setMessage(`${json.message}`);
            }
        } catch (error) {
            setSuccess(false);
            setLoading(false);
            setOpen(true);
            //setAuth(false);
            setMessage(`Error ${error}`);
        }
    };


    return (
    <>
        <Container>
            <Centered>
                <Header>
                    <Title>Login</Title>
                </Header>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <InputWrap>
                        <TextField required id="email" type="email" autoComplete="off" label="email" color="secondary" size="small" value={email} onChange={e => setEmail(e.target.value)} />
                    </InputWrap>
                    <InputWrap>
                        <TextField required id="password" label="password" color="secondary" size="small" type="password" value={password} onChange={e => setPassword(e.target.value)} />
                    </InputWrap>
                    <ButtonWrapper>
                        <ButtonLogin fullWidth variant="outlined"
                            type="submit" disabled={!validateForm()}
                        >
                            Login
                        </ButtonLogin>
                        {loading && <CircularProgressExt size={24} />}
                    </ButtonWrapper>
                    <ForgotWrapper>
                    <Link onClick={()=>setIsForgot(true)}>Forgot your password?</Link>
                    </ForgotWrapper>
                </form>
            </Centered>
            <Snackbar open={open} autoHideDuration={8000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                {success ?
                    <Alert onClose={handleClose} severity="success">
                        {message}
                    </Alert>
                    :
                    <Alert onClose={handleClose} severity="error">{message}</Alert>
                }
            </Snackbar>
       
        </Container>
     
        </>
    )
}
/*
     
*/
const Container = styled.div`
  background-color: antiquewhite;
  height:90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image:url(${background});
  background-size: cover;
  background-position: center;
`;
/*
  backgroundImage: `url(${background})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
*/
const Centered = styled.div`
   width: 250px;
   height: 300px;
   background-color: white;
   position: absolute;
   margin: auto;
   border-radius: 10px;
`;

const Header = styled.div`
  padding-top: 15px;
`;

const Title = styled.h3`
  border-left: solid 5px #009edb;
  color: #009edb;
  padding-left: 10px;
`;

const InputWrap = styled.div`
  padding-top: 1em;
  padding-left: 1em;
  padding-right: 1em;
`;

const ButtonWrapper = styled.div`
  position: relative;
  padding-top: 2em;
  padding-left: 1em;
  padding-right: 1em;
`;
const ForgotWrapper = styled.div`
  position: relative;
  text-align: center;
  padding-top: 0.2em;
  cursor: pointer;
`;

const ButtonLogin = styled(Button)`
  :hover{
      background-color: #EF4C4C!important;
      color: white;
  }
`;

const CircularProgressExt = styled(CircularProgress)`
    color: green;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 5px;
    margin-left: -12px;
`;

/*


   buttonProgress: {
       color: green[500],
       position: 'absolute',
       top: '50%',
       left: '50%',
       marginTop: 5,
       marginLeft: -12,
   },
   buttonSuccess: {
       backgroundColor: green[500],
       color: "white",
       border: "none",
       '&:hover': {
           backgroundColor: green[700],
       },
   },
   icon: {
       fontSize: "16px",
       marginLeft: "-10px",
       marginRight: "5px"
   }
 //backgroundImage: url(${background}),
 //backgroundSize: 'cover',
 //backgroundPosition: 'center',
 //backgroundColor: "darkgrey",
 */